import React from 'react'
import {
  ModalBackdrop,
  ModalContainer,
  ModalDialog,
} from '@heroui/react'
import { cn } from '../../utils/cn'
import { useIsMobile } from '../../hooks/useIsMobile'

/**
 * MobileSheetModal — 移动端底部 Sheet / 桌面端居中 Modal
 *
 * 用法：
 *   <MobileSheetModal isOpen={...} onOpenChange={...} size="md" variant="blur">
 *     <ModalHeader>...</ModalHeader>
 *     <ModalBody>...</ModalBody>
 *     <ModalFooter>...</ModalFooter>
 *   </MobileSheetModal>
 *
 * - 移动端 (< lg): ModalContainer 贴底, ModalDialog 顶部圆角, 宽度撑满, 最大高度 85dvh, 底部 padding 含 safe-area
 * - 桌面端: 与原生 ModalBackdrop+Container+Dialog 行为一致, 透传 size/placement/scroll
 *
 * 注: containerProps / dialogProps 可用于透传 HeroUI v3 的特殊 prop (如 scroll, placement)
 */
const MobileSheetModal = ({
  isOpen,
  onOpenChange,
  size = 'md',
  variant = 'blur',
  placement,
  scroll,
  containerClassName = '',
  dialogClassName = '',
  containerProps,
  dialogProps,
  children,
}) => {
  const isMobile = useIsMobile()

  return (
    <ModalBackdrop isOpen={isOpen} onOpenChange={onOpenChange} variant={variant}>
      <ModalContainer
        size={size}
        placement={placement}
        scroll={scroll}
        className={cn(
          isMobile && '!items-end !justify-stretch',
          containerClassName,
        )}
        {...containerProps}
      >
        <ModalDialog
          className={cn(
            isMobile &&
              'w-full max-w-full mt-auto mb-0 rounded-t-3xl rounded-b-none pb-[max(1rem,env(safe-area-inset-bottom))] max-h-[85dvh] overflow-y-auto',
            dialogClassName,
          )}
          {...dialogProps}
        >
          {children}
        </ModalDialog>
      </ModalContainer>
    </ModalBackdrop>
  )
}

export default MobileSheetModal
